// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '오스코리아제약',
  targetSheetName: '종합 (3)',
  headerRowIndex: 2,
  headerRowCount: 2,
  dataStartRowIndex: 4,
  columnMapping: {
    drugName: '품목',
    commissionRate: '현재',
    commissionNote: '비고',
  },
  requiredHeaders: ['NO', '품목', '현재', '비고'],
});
